/*
 * month=YYYY-MM in the URL on every Teacher Payments page, so a link can be shared or refreshed
 * without losing the selected month.
 */
const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

// 'month=' first; a legacy 'pay_month=' deep link (the overview/needs_attention Slack digest links,
// and close_versions' own view-state param) still works.
export const month_from_search = (search) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const month = (qs.get('month') || '').trim();
  if (MONTH_RE.test(month)) return month;
  const legacy = (qs.get('pay_month') || '').trim();
  return MONTH_RE.test(legacy) ? legacy : '';
};

// Merges 'month' into the existing search, keeping every other param untouched; '' removes it.
export const with_month = (search, pay_month) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  if (pay_month) qs.set('month', pay_month);
  else qs.delete('month');
  return qs.toString();
};
